AF = AF || {}
AF.UI = AF.UI || {}

AF.UI.coverOn = function (message = '', imageName = 'loading.gif', opacity = 0.95) {
  $('#loading').addClass('loading-show-by-default').css({
    'opacity': '1',
    'width': '100%',
    'height': '100%',
    background: 'rgba(68,68,68,' + opacity + ')'
  })

  $('#img-loading').attr('src', '/img/' + imageName)

  const $loadingMessage = $('#loading-message')
  if (message) {
    $loadingMessage.text(message).show()
  } else {
    $loadingMessage.hide()
  }
}

AF.UI.coverOff = function () {
  $('#loading').removeClass('loading-show-by-default').css({
    'opacity': '0',
    'width': '0',
    'height': '0'
  })
  $('#loading-message').hide().text('')
}

AF.UI.notify = {}

AF.UI.notify.success = function (message, settings = {}) {

  const defaultSettings = {
    type: 'success',
    placement: {
      from: 'top',
      align: 'center'
    },
    z_index: 9999999999
  }

  const config = Object.assign({}, defaultSettings, settings)

  return $.notify({message: message}, config)
}

AF.UI.notify.error = function (message, settings = {}) {

  const defaultSettings = {
    type: 'danger',
    placement: {
      from: 'top',
      align: 'center'
    },
    z_index: 9999999999
  }

  let content = {
    message: '',
  }

  if (typeof message === 'object') {
    content = Object.assign({}, content, message)
  } else if (typeof message === 'string') {
    content.message = message
  }

  const config = Object.assign({}, defaultSettings, settings)

  return $.notify(content, config)
}

AF.UI.notify.info = function (message, settings = {}) {

  const defaultSettings = {
    type: 'info',
    placement: {
      from: 'top',
      align: 'center'
    },
    z_index: 9999999999,
    timer: 60000
  }

  const config = Object.assign({}, defaultSettings, settings)

  return $.notify({message: message}, config)
}

AF.UI.notify.warning = function (message, settings = {}) {

  const defaultSettings = {
    type: 'warning',
    placement: {
      from: 'top',
      align: 'center'
    },
    z_index: 9999999999,
    timer: 60000
  }

  let content = {
    message: '',
  }

  if (typeof message === 'object') {
    content = Object.assign({}, content, message)
  } else if (typeof message === 'string') {
    content.message = message
  }

  const config = Object.assign({}, defaultSettings, settings)

  return $.notify(content, config)
}

AF.UI.confirm = function (msg, cb) {
  $.confirm({
    title: 'Confirmation',
    content: msg,
    buttons: {
      confirm: function () {
        cb()
      },
      cancel: function () {
      }
    }
  })
}

AF.UI.alert = {}

AF.UI.alert.success = function (message) {
  alertify.success(message)
}

AF.UI.alert.error = function (message) {
  alertify.error(message)
}

$(document).on('click', '[data-role="af-confirm"]', function (e) {
  e.preventDefault()
  let href = $(this).attr('href')
  if (!href) {
    return
  }
  AF.UI.confirm('Are you sure that you want to perform this action?', function () {
    AF.UI.coverOn()
    location.href = href
  })
})

$(document).on('click', '[data-role="af-loader"]', function (e) {
  AF.UI.coverOn()
})

$('[data-role=\'af-form\']').parsley()

// Full-page forms get the cover until the next page paints over it. Forms that
// Livewire or Alpine submit in place never reload, so the cover would stay up.
$('form:not(.disable-cover)').on('submit', function () {
  if (this.closest('[wire\\:id]') || this.hasAttribute('x-on:submit') || this.hasAttribute('@submit') || this.hasAttribute('x-on:submit.prevent') || this.hasAttribute('@submit.prevent')) {
    return
  }
  AF.UI.coverOn()
})

$(document).ready(function () {

  //select handlers

  $('[data-role=\'af-select\']').each(function () {
    let selected = $(this).data('selected')
    $(this).val(selected)
  })

  $('[data-role-1=\'af-table-n-display\']').change(function () {
    let url = new URL(window.location.href)
    url.searchParams.set('page_size', $(this).val())
    AF.UI.coverOn()
    window.location.href = url.href
  })

})

//variables to store dropzone information

AF.UI.dropzone = {
  uploadedCanceled: false,

}

//Livewire Events
if (Livewire) {
  Livewire.on('LW.refreshPage', function () {
    window.location.reload()
  })
}



